import React from "react";
import { useSelector } from "react-redux";
import { ListGroup } from "reactstrap";
import { getSortedRestaurantsSelector } from "../../store/restaurantsStore/selectors";
import ListItem from "./ListItem";

export default () => {
  const restaurants = useSelector(getSortedRestaurantsSelector);
  return (
    <ListGroup>
      {restaurants.map(restaurant => (
        <ListItem restaurant={restaurant} key={restaurant.key} />
      ))}
    </ListGroup>
  );
};
